/**
 * Created by Simone.Sacchi on 29/11/2017.
 */


"use strict";

module.exports = {

    getCsrfToken () {
        return $('meta[name="csrf-token"]').attr('content');
    },

    getCurrentlyActiveTab (tablistSelector) {
        // ul#institutions_details_sub_nav
        return $(`${tablistSelector  } > li.active a`).attr("aria-controls");
    },

    getSsiOwnerBic () {
        return $("#search__details__content--ssis .search_details_header a[data-feedback-type='bic']:visible").text() ||
            $(".search_details_header .current-bic:visible").attr('data-bic') ||
            "";
    },

    /**
     * Build a microservice url
     *
     * ex call: buildMicroserviceUrl(["autocomplete", "e1s1", "reachable", "bic"]);
     * ex response: /services/autocomplete/e1s1/reachable/bic
     *
     * NOTE: if you want you can also pass the querystring because it will be concatenated
     * ex call: buildMicroserviceUrl(["autocomplete", "e1s1", "reachable", "bic", "a=test&b=a"]);
     * @param segments
     * @returns {string}
     */
    buildMicroserviceUrl (segments) {
        // Redirect old microservices_autocomplete e1s1 endpoints to microservices_e1s1_node
        if (segments[0] === "autocomplete" && segments[1] === "e1s1") {
            segments.unshift("e1s1");
        }
        return `${window.Swiftref.base_url  }/services/${  segments.join("/")}`;
    },

    /**
     * delete specified keys from object
     *
     * @param obj
     * @param keys array of keys
     * @returns {*}
     */
    deleteKeys (obj, keys) {

        const cloneObj = { ...obj};

        keys.forEach((key) => {

            if (cloneObj.hasOwnProperty(key)) {
                delete cloneObj[key];
            }
        });

        return cloneObj;
    },

    findParentByClass (element, className) {
        try {
            while (!element.classList.contains(className)) {
                element = element.parentNode;
            }
            return element;
        } catch (e) {}
    },
    findParentByTagName (element, tagName) {
        if (!element) {
            return;
        }
        while (element.tagName && element.tagName !== tagName) {
            element = element.parentNode;
        }
        return element;
    },

    // used for feedback, to return the current section
    getCurrentCategory (hash) {
        if (window.location.pathname.includes("prevalidations")) {
            return 'preval_bav_service';
        }

        if (hash && hash.tab) {
            if (hash.tab === 'countries_currencies') {
                return 'cch';
            }
            return hash.tab;
        }

        if (window.location.pathname) {
            const category = categoryFromPathname(window.location.pathname);
            if (category !== null) {
                return category;
            }
        }

        return "";
    }


};

/**
 * Map a pathname to its feedback category. Later matches override earlier ones.
 *
 * @param {string} pathname
 * @returns {string|null}
 */
function categoryFromPathname(pathname) {
    let category = null;
    if (pathname.includes("ssipath")) {
        category = 'ssi_path';
    }
    if (pathname.includes("iban")) {
        category = 'iban_validator';
    }
    if (pathname.includes("cch")) {
        category = 'cch';
    }
    if (pathname.includes("download")) {
        category = 'download_area';
    }
    if (pathname.includes("datacollection")) {
        if (pathname.includes("4ec")) {
            category = 'admin';
        } else if (pathname.includes("gpi")) {
            category = 'gpi';
        } else if (pathname.includes("sepa")) {
            category = 'sepa';
        } else if (pathname.includes("tradereadiness")) {
            category = 'trade';
        }
    }
    if (pathname.includes("g4cs") && !pathname.includes("datacollection")) {
        category = 'gpi_for_corporates';
    }
    if (pathname.includes("sepaio")) {
        category = 'sepa_iban';
    }
    return category;
}
